export const getHTTPProtocol = (resourceTimings: PerformanceEntry[]) => {
	let hasScriptEntries = false;
	let hasNextHopProtocolProperty = false;

	for (const entry of resourceTimings as PerformanceResourceTiming[]) {
		if (entry.initiatorType !== 'script') {
			continue;
		}

		hasScriptEntries = true;

		// Skip cache hits. Cached resources have transferSize === 0 and the browser reports
		// nextHopProtocol as "" since no network hop occurred.
		if (entry.transferSize === 0) {
			continue;
		}

		if ('nextHopProtocol' in entry) {
			hasNextHopProtocolProperty = true;
			if (entry.nextHopProtocol) {
				return entry.nextHopProtocol;
			}
		}
	}

	if (!hasScriptEntries || !hasNextHopProtocolProperty) {
		return 'unsupported';
	}

	return 'unknown';
};
